<footer>
    <div class="container-lg ht-grid">
        <div class="footer-link flex flex-column align-center">
            <ul>
                <li><a routerLink="">Accueil</a></li>
                <li><a routerLink="contact">Contactez nous</a></li>
                <li><a routerLink="vos-avis">Avis et témoignages</a></li>
                <li><a routerLink="presentation">Qui sommes nous</a></li>
                <!-- <li><a routerLink="nos-partenaires">Partenaires</a></li> -->
                <li><a routerLink="back-office">Back-office</a></li>
            </ul>
        </div>
        <div class="footer-horaire flex flex-column align-center">
            <div class="footer-horaire-top">
                <div>Horaires d'ouverture</div>
            </div>
            <div class="footer-horaire-middle">
                <div>Du Lundi au Vendredi</div>
                <div>de 08:00 à 20:30</div>
            </div>
            <div class="footer-horaire-bottom">
                <div>Le Samedi</div>
                <div>de 08:00 à 12:00</div>
            </div>
        </div>
        <div class="footer-reseaux flex flex-column align-center">
            <div>Suivez notre activité</div>
            <div class="logo-reseaux-footer">
                <a href="https://www.facebook.com/JordanKrsticCoaching" target="_blank">
                    <i class="bi bi-facebook"></i>
                </a>
                <a href="https://www.instagram.com/heat.training/" target="_blank">
                    <i class="bi bi-instagram"></i>
                </a>
            </div>
        </div>
    </div>
</footer>
